/* =============================================================
   ALI3N LAB — parallax-home.js
   Shared JS for all home page sections.
   Upload once to: Online Store → Themes → Edit code → Assets
============================================================= */

function ali3nHomeInit() {

  /* ── WOBBLE SVG FILTER (ticker banners) ───────────────────── */
  var svgNS = 'http://www.w3.org/2000/svg';
  var filterSVG = document.createElementNS(svgNS, 'svg');
  filterSVG.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
  filterSVG.innerHTML =
    '<defs>' +
      '<filter id="ali3nWobble" x="-5%" y="-15%" width="110%" height="130%">' +
        '<feTurbulence id="ali3nTurb" type="turbulence" ' +
          'baseFrequency="0.010 0.014" numOctaves="3" seed="1" result="warp"/>' +
        '<feDisplacementMap id="ali3nDmap" in="SourceGraphic" in2="warp" ' +
          'scale="1.4" xChannelSelector="R" yChannelSelector="G"/>' +
      '</filter>' +
    '</defs>';
  document.body.prepend(filterSVG);

  var wobbleTurb  = document.getElementById('ali3nTurb');
  var wobbleDmap  = document.getElementById('ali3nDmap');
  var wobbleFPS   = 10;
  var wobbleLast  = 0;
  var wobblePhase = 0;

  function updateWobble(ts) {
    requestAnimationFrame(updateWobble);
    if (ts - wobbleLast < 1000 / wobbleFPS) return;
    wobbleLast  = ts;
    wobblePhase += 0.05 + Math.random() * 0.02;
    var bfx = (0.010 + Math.sin(wobblePhase * 0.7) * 0.002 + (Math.random() - 0.5) * 0.0015).toFixed(4);
    var bfy = (0.014 + Math.cos(wobblePhase * 0.5) * 0.002 + (Math.random() - 0.5) * 0.0015).toFixed(4);
    var sc  = (1.4   + Math.sin(wobblePhase) * 0.4  + (Math.random() - 0.5) * 0.35).toFixed(2);
    if (wobbleTurb) {
      wobbleTurb.setAttribute('baseFrequency', bfx + ' ' + bfy);
      wobbleTurb.setAttribute('seed', Math.floor(Math.random() * 9999));
    }
    if (wobbleDmap) wobbleDmap.setAttribute('scale', sc);
  }
  requestAnimationFrame(updateWobble);

  /* ── VERTICAL PARALLAX ────────────────────────────────────── */
  var parallaxEls = document.querySelectorAll('.ali3n-parallax[data-speed]');

  // Elements that need a fixed positioning transform (e.g. centering)
  // preserved on every scroll tick. Reading el.style.transform doesn't
  // work for this — it only ever reflects what THIS script already set
  // inline, never a transform defined in the stylesheet, so the very
  // first tick would silently wipe out any CSS-only transform.
  var PARALLAX_BASE_TRANSFORM = {
    's1__title':       'translateX(-50%)',
    's1__leaves-fore':  'translate(-50%, -43%)',
    's1__ufo-wrap':     'translateX(-50%)'
  };

  function runParallax() {
    var scrollY = window.scrollY;
    for (var i = 0; i < parallaxEls.length; i++) {
      var el    = parallaxEls[i];
      var speed = parseFloat(el.dataset.speed) || 0;
      var base  = '';
      for (var cls in PARALLAX_BASE_TRANSFORM) {
        if (el.classList.contains(cls)) { base = PARALLAX_BASE_TRANSFORM[cls]; break; }
      }
      el.style.transform = (base ? base + ' ' : '') +
                           'translateY(' + (scrollY * speed) + 'px)';
    }
  }

  window.addEventListener('scroll', function () {
    requestAnimationFrame(runParallax);
  }, { passive: true });
  runParallax();

  /* ── SECTION 2: HORIZONTAL LEAF PARALLAX ─────────────────── */
  var s2 = document.getElementById('s2');

  // Left-side layers slide in from left
  var s2Left = [
    document.querySelector('.s2__fern'),
    document.querySelector('.s2__hosta'),
    document.querySelector('.s2__blades')
  ].filter(Boolean);

  // Right-side layers slide in from right
  var s2Right = [
    document.querySelector('.s2__gold'),
    document.querySelector('.s2__small-right')
  ].filter(Boolean);

  // Start off-screen
  s2Left.forEach(function (el) {
    el.style.transform = 'translateX(-110%) translateY(0px)';
  });
  s2Right.forEach(function (el) {
    el.style.transform = 'translateX(110%) translateY(0px)';
  });

  function runS2() {
    if (!s2) return;
    var rect     = s2.getBoundingClientRect();
    var viewH    = window.innerHeight;
    // progress: 0 = s2 bottom just entering viewport, 1 = s2 top at viewport top
    var raw      = 1 - (rect.top / viewH);
    var progress = Math.max(0, Math.min(1, raw));
    // Ease out so leaves decelerate as they close
    var eased    = 1 - Math.pow(1 - progress, 2.2);

    s2Left.forEach(function (el, i) {
      var stagger = i * 6;
      var lx = Math.min(0, -110 + eased * (110 + stagger));
      var ly = window.scrollY * (0.08 + i * 0.1);
      el.style.transform = 'translateX(' + lx + '%) translateY(' + ly + 'px)';
    });

    s2Right.forEach(function (el, i) {
      var stagger = i * 6;
      var rx = Math.max(0, 110 - eased * (110 + stagger));
      var ly = window.scrollY * (0.18 + i * 0.12);
      el.style.transform = 'translateX(' + rx + '%) translateY(' + ly + 'px)';
    });
  }

  window.addEventListener('scroll', function () {
    requestAnimationFrame(runS2);
  }, { passive: true });
  runS2();

  /* ── EYE BLINKING ─────────────────────────────────────────── */
  var blinkEyes = document.querySelectorAll('.ali3n-blink-eye');

  // Preload every closed-eye image up front so the first blink swap is
  // instant, not waiting on a fresh network fetch (the alien's image is
  // large, 986x929, so this matters most there).
  blinkEyes.forEach(function (eye) {
    if (eye.dataset.closed) {
      var preload = new Image();
      preload.src = eye.dataset.closed;
    }
  });

  function startBlinking(eye) {
    function doBlink() {
      eye.src = eye.dataset.closed;
      eye.classList.add('is-blinking');
      setTimeout(function () {
        eye.src = eye.dataset.open;
        eye.classList.remove('is-blinking');
        // Random interval between 1.8s and 5.5s
        setTimeout(doBlink, 1800 + Math.random() * 3700);
      }, 140);
    }
    // Stagger initial blink so all eyes don't blink at once
    setTimeout(doBlink, Math.random() * 3000);
  }

  blinkEyes.forEach(startBlinking);

  /* ── ROLLING PILLBUG ──────────────────────────────────────── */
  var pillbugWrap   = document.getElementById('s1PillbugBall');
  var pillbugBall   = document.getElementById('s1PillbugBallImg');
  var pillbugShadow = document.getElementById('s1PillbugShadow');
  var s1            = document.getElementById('s1');
  var s2El          = document.getElementById('s2');
  var leafRight     = document.querySelector('.s1__leaf-back-right img');

  var DEPARTURE   = 0.22;
  var bounceFired = false;

  function runPillbug() {
    if (!s1 || !pillbugWrap) return;
    var s1H      = s1.offsetHeight;
    var scrollY  = window.scrollY;
    var pinStart = s1H * 0.45;
    /* Section 2 (id="s2") doesn't exist yet in some builds — fall back to an
       estimate (80% of section 1's height) so the ball is visible/testable
       now. Once section-leaves-ali3n.liquid ships with id="s2", this
       automatically switches to using its real height instead. */
    var s2Height = s2El ? s2El.offsetHeight : s1H * 0.8;
    var pinEnd   = s1H + s2Height;
    var progress = Math.max(0, Math.min(1, (scrollY - pinStart) / (pinEnd - pinStart)));

    pillbugWrap.classList.toggle('visible', progress > 0 && progress < 1);

    var rotation = progress * 720;
    if (pillbugBall) {
      pillbugBall.style.transform = 'rotate(' + rotation + 'deg)';
    }

    if (pillbugShadow) {
      if (progress < DEPARTURE) {
        var squish = 1 - (progress / DEPARTURE) * 0.3;
        pillbugShadow.style.opacity   = '0.45';
        pillbugShadow.style.transform = 'translateX(-50%) scaleX(' + squish.toFixed(3) + ')';
        pillbugShadow.style.filter    = 'blur(3px)';
      } else {
        var fallP   = (progress - DEPARTURE) / (1 - DEPARTURE);
        var opacity = Math.max(0, 0.45 * (1 - fallP));
        var scale   = Math.max(0.1, 1 - fallP * 0.75);
        var blur    = 3 + fallP * 12;
        pillbugShadow.style.opacity   = opacity.toFixed(3);
        pillbugShadow.style.transform = 'translateX(-50%) scaleX(' + scale.toFixed(3) + ')';
        pillbugShadow.style.filter    = 'blur(' + blur.toFixed(1) + 'px)';

        if (!bounceFired && leafRight) {
          leafRight.classList.add('leaf-bouncing');
          bounceFired = true;
          setTimeout(function () {
            leafRight.classList.remove('leaf-bouncing');
          }, 900);
        }
      }
    }
  }

  window.addEventListener('scroll', function () {
    requestAnimationFrame(runPillbug);
  }, { passive: true });
  runPillbug();

  /* ── RANDOM SPEECH BUBBLE QUOTE ───────────────────────────── */
  var quotes = document.querySelectorAll('.s3__quote');
  if (quotes.length) {
    quotes.forEach(function (q) { q.classList.remove('active'); });
    quotes[Math.floor(Math.random() * quotes.length)].classList.add('active');
  }

  /* ── GRASS ROOTS: visible during s5 and s6 ───────────────── */
  var roots = document.getElementById('ali3nRoots');
  var s5    = document.getElementById('s5');
  var s6    = document.getElementById('s6');

  function runRoots() {
    if (!roots) return;
    var show = false;
    if (s5) {
      var r5 = s5.getBoundingClientRect();
      if (r5.top < window.innerHeight && r5.bottom > 0) show = true;
    }
    if (s6) {
      var r6 = s6.getBoundingClientRect();
      if (r6.top < window.innerHeight && r6.bottom > 0) show = true;
    }
    roots.classList.toggle('visible', show);
  }

  window.addEventListener('scroll', function () {
    requestAnimationFrame(runRoots);
  }, { passive: true });
  runRoots();

  /* ── CUSTOM CURSOR (pigeon section) ───────────────────────── */
  var cursor = document.getElementById('ali3nCursor');
  var s5El   = document.getElementById('s5');

  if (cursor) {
    document.addEventListener('mousemove', function (e) {
      cursor.style.left = e.clientX + 'px';
      cursor.style.top  = e.clientY + 'px';
    });
    if (s5El) {
      s5El.addEventListener('mouseenter', function () {
        cursor.classList.add('visible');
        document.body.style.cursor = 'none';
      });
      s5El.addEventListener('mouseleave', function () {
        cursor.classList.remove('visible');
        document.body.style.cursor = '';
      });
    }
  }

  /* ── PIGEON MODAL ─────────────────────────────────────────── */
  var pigeonBtn      = document.getElementById('s5PigeonBtn');
  var modalOverlay   = document.getElementById('ali3nModal');
  var modalClose     = document.getElementById('ali3nModalClose');
  var modalPaper     = document.getElementById('ali3nModalPaper');
  var modalEnvFront  = document.getElementById('ali3nModalEnvFront');
  var modalStickers  = document.querySelectorAll('.ali3n-modal-sticker');
  var modalEmail     = document.getElementById('ali3nModalEmail');
  var modalSuccess   = document.getElementById('ali3nModalSuccess');
  var mailingForm    = document.getElementById('ali3nMailingForm');

  function openModal() {
    if (!modalOverlay) return;
    modalOverlay.classList.add('open');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        if (modalPaper)    modalPaper.classList.add('open');
        if (modalEnvFront) modalEnvFront.classList.add('opened');
        modalStickers.forEach(function (s, i) {
          setTimeout(function () { s.classList.add('fanned'); }, 180 + i * 55);
        });
      });
    });
  }

  function closeModal() {
    if (!modalOverlay) return;
    if (modalPaper)    modalPaper.classList.remove('open');
    if (modalEnvFront) modalEnvFront.classList.remove('opened');
    modalStickers.forEach(function (s) { s.classList.remove('fanned'); });
    setTimeout(function () { modalOverlay.classList.remove('open'); }, 550);
  }

  if (pigeonBtn)   pigeonBtn.addEventListener('click', openModal);
  if (modalClose)  modalClose.addEventListener('click', closeModal);
  if (modalOverlay) {
    modalOverlay.addEventListener('click', function (e) {
      if (e.target === modalOverlay) closeModal();
    });
  }

  if (mailingForm) {
    mailingForm.addEventListener('submit', function (e) {
      if (!modalEmail || !modalEmail.value || !modalEmail.value.includes('@')) {
        e.preventDefault();
        if (modalEmail) modalEmail.classList.add('error');
        return;
      }
      if (modalEmail) modalEmail.classList.remove('error');
      setTimeout(function () {
        if (modalEmail) modalEmail.style.display = 'none';
        var btn = mailingForm.querySelector('.ali3n-modal-submit');
        if (btn) btn.style.display = 'none';
        if (modalSuccess) modalSuccess.style.display = 'block';
      }, 350);
    });
    if (modalEmail) {
      modalEmail.addEventListener('input', function () {
        modalEmail.classList.remove('error');
      });
    }
  }

  /* ── TICKER BANNER: duplicate until 3× viewport width ─────── */
  var tickerInner = document.getElementById('ali3nTickerInner');
  if (tickerInner) {
    var originalHTML = tickerInner.innerHTML;
    // Keep duplicating until content is at least 3× viewport wide
    while (tickerInner.scrollWidth < window.innerWidth * 3) {
      tickerInner.innerHTML += originalHTML;
    }
    // Animate at constant speed: 80px per second
    var totalW    = tickerInner.scrollWidth / 2; // half because we animate -50%
    var speed     = 80; // px/s
    var duration  = totalW / speed;
    tickerInner.style.animation = 'ali3nTickerScroll ' + duration.toFixed(1) + 's linear infinite';
  }

}

/* Run once the DOM is parsed. Deliberately NOT waiting on window 'load' —
   'load' only fires once every network request the page kicked off has
   settled, including background pings (e.g. Shopify's own perf-kit beacon),
   and if one of those never resolves, 'load' may never fire either,
   silently skipping init forever. Nothing in this script actually needs
   images to have finished downloading — every size/position calculation
   uses explicit width/height attributes or fixed CSS values. */
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', ali3nHomeInit);
} else {
  ali3nHomeInit();
}

/* Ticker keyframe — defined outside load so it's available immediately */
(function () {
  var style = document.createElement('style');
  style.textContent = '@keyframes ali3nTickerScroll { from { transform: translateX(0); } to { transform: translateX(-50%); } }';
  document.head.appendChild(style);
}());
